<template>
  <div class="nav201 pt-1 d-flex justify-content-center align-items-center fixed-bottom ">
    <div id="mySidenav" ref="sidenav"
         class="sidenav m-auto d-flex justify-content-center align-items-center icon-menu-styles closebtn mx-auto">

      <div @click="closeNav()"
           class="col d-flex flex-column text-center align-items-center icon-style  icon-menu-close">
        <i class="bi bi-x p-0   nav305-nav-icon "></i>
        <span class="nav201-navigation-name " v-t="`nav.close_menu`"></span>
      </div>

      <div class="col nav-201-categories d-flex flex-column text-center align-items-center icon-style"
           data-toggle="modal"
           :data-target="`${navDataToggle}`">
        <m-icon class="p-0 nav305-nav-icon"
                icon="list"/>
        <span class="nav201-navigation-name " v-t="`nav.side_toggler`"></span>
      </div>

      <div class="col nav-201-home d-flex flex-column text-center align-items-center">
        <m-a :href="{name:'Home'}" class="text-decoration-none">
          <m-icon class="p-0  nav305-nav-icon" icon="house-fill"/>
          <span class="nav201-navigation-name" v-t="`nav.home`"></span>
        </m-a>
      </div>

      <div class="col nav-201-shopping-cart d-flex flex-column text-center align-items-center">
        <m-a :href="{name:'ShoppingCart'}" class="text-decoration-none">
          <i class="bi bi-cart-fill p-0  nav305-nav-icon"></i>
          <span class="nav201-navigation-name" v-t="`nav.shopping_cart`"></span>
        </m-a>
      </div>

      <slot>
        <div class="col d-flex flex-column text-center align-items-center  nav-201-whatsapp">
          <m-a :href="`https://wa.me/${findAttributeOnSiteInfo('social_media_whatsapp')[0]}`">
            <i class="bi bi-whatsapp nav305-nav-icon"></i>
            <span class="nav201-navigation-name mt-1">
             مشاوره
            </span>
          </m-a>
        </div>
      </slot>


    </div>
    <div @click="openNav()"
         class="col-12 col-lg-4 col-sm-4 col-md-4 text-end nav201-toggle-button
          d-flex justify-content-center align-items-center">
      <div class="font-weight-bolder h5 text-center mt-1">
        <i class="bi bi-list "></i>
      </div>
    </div>
  </div>

</template>

<script>
import mBaseMenu from "../Menu/BaseMenu.vue";
import {MenuProps} from "../Menu/MenuProps";
import mSearchInput1 from "../Search/Input/SearchInput1.vue";
import mIcon from "../Icons/Icon.vue";
import mA from "../Tags/A.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "Nav201",
  components: {mIcon, mSearchInput1, mBaseMenu, mA},
  props: {
    ...MenuProps,
    navDataToggle: {
      options: ['#nav-305-menu', '#nav200-modal'],
      default: '#nav-305-menu',
    }
  },
  data() {
    return {
      body: null,
      screenSize: window.innerWidth,
      mobileScreen: 712
    }
  },
  computed: {
    isDesktopScreen() {
      return this.screenSize >= this.mobileScreen;
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    goBack() {
      this.$router.back();
    },
    openNav() {
      const mySidenav = this.$refs.sidenav
      mySidenav.style.width = "98%";
      if (this.isDesktopScreen) { // if not in mobile
        this.body.style.transition = 'margin-left .5s'

      }
    },
    closeNav() {
      const mySidenav = this.$refs.sidenav
      mySidenav.style.width = "0";
      this.body.style.marginRight = "0";
    }
  },
  beforeMount() {
    this.body = document.querySelector("body")
  },
  mounted() {
    if (!this.isDesktopScreen) {
      this.closeNav()
    }
  }
}
</script>


<style scoped>
.nav201 {
  background: var(--primary);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 10px;
  margin-right: 15px;
}

.icon-menu-styles {
  border-radius: 30px;
  margin-bottom: 5px !important;
  left: 10%;
  right: 1% !important;
}

.sidenav {
  height: 70px;
  width: 100%;
  position: fixed;
  z-index: 1;
  right: 0;
  background-color: var(--dark);
  overflow-x: hidden;
  transition: 0.5s;
}

.sidenav :deep(.base-menu-item-icon) {
  display: inline-block !important;
  margin: 0 7px;
}

.sidenav :deep(.base-menu-item-wrapper) {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 20px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidenav :deep(.base-menu-item-wrapper):hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  color: var(--white);
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}


.nav308-search :deep(form), .nav308-search :deep(input) {
  border-radius: 9px;
}

.sidenav {
  bottom: 0;
  width: 100%;
}

.nav305-nav-icon {
  font-size: 20px;
}

.nav201-navigation-name {
  font-size: 9px;
  display: block;
  text-align: center;
  width: 50px;
}

.icon-menu-styles * {
  color: var(--secondary);
  cursor: pointer;
}

.icon-style {
  width: 50px;
}
</style>
